import axios from 'axios'
import qs from 'qs'
import { mergeLeft } from 'ramda'
import base64 from 'base64-js'
import { getUnixTime } from 'date-fns'
import { ESig } from '@/pb/signaling_param_pb'
import { MICROPHONEAUTHSTATES } from '@/utils/microPhoneAuthCheck'
import i18n from '@/i18n'
import pkg from '../package.json'

export function genNonce(len) {
  let text = ''
  const dict = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < len; i++) {
    text += dict.charAt(Math.floor(Math.random() * dict.length))
  }
  return text
}

export default {
  appkey: 'HiARGlasses',
  secret: '72adcf2045f79c720879cb28901730fc',
  resolvePath(path, domain) {
    if (/^(https?:)\/\//.test(path)) {
      return path
    }
    domain = domain || ''
    if (path.charAt(0) !== '/') {
      path = '/' + path
    }
    return domain + path
  },
  genNonce,
  postAsForm(url, payload /* axios data obj */, config) {
    return axios.post(
      url,
      qs.stringify(payload),
      mergeLeft({
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }, config)
    )
  },
  base64Decode(src) {
    console.log('base64 decode from', src)
    const byteArray = base64.toByteArray(src)
    return Buffer.prototype.toString.call(byteArray) // 默认按utf8编码
  },
  base64Encode(src) {
    const byteArray = Uint8Array.from(src, str => str.charCodeAt(0))
    return base64.fromByteArray(byteArray)
  },
  dateAsSecond(date) {
    return getUnixTime(date)
  },
  // 对于服务端能以json格式返回bytes数据，需用此方法转换成json字符串
  uint8ArrayToString(arr) {
    return new TextDecoder('UTF-8').decode(arr)
  },
  throttle (func, limit) {
    let lastFunc
    let lastRan
    return function() {
      const context = this
      const args = arguments
      if (!lastRan) {
        func.apply(context, args)
        lastRan = Date.now()
      } else {
        clearTimeout(lastFunc)
        lastFunc = setTimeout(function() {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args)
            lastRan = Date.now()
          }
        }, limit - (Date.now() - lastRan))
      }
    }
  },
  // 页面可见性改变的事件
  addPageVisibilityChangeEvent (visibleCallback, hiddenCallback) {
    let hidden, visibilityChange
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden'
      visibilityChange = 'visibilitychange'
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden'
      visibilityChange = 'msvisibilitychange'
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden'
      visibilityChange = 'webkitvisibilitychange'
    }
    document.addEventListener(visibilityChange, () => {
      if (document[hidden]) {
        // 页面隐藏时的回调
        typeof hiddenCallback === 'function' && hiddenCallback()
      } else {
        // 页面可见时的回调
        typeof visibleCallback === 'function' && visibleCallback()
      }
    }, false)
  },
  sessionKeepAliveInterval: 15000/* ms */,
  sessionKeepAliveTimeout: 15000/* ms */,
  userKeepAliveInterval: 15000/* ms */,
  userKeepAliveTimeout: 15000/* ms */,
  callTimeout: 60000/* ms */,
  HIMDeviceType: {
    kHIMDeviceType_Windows: 4,
    kHIMDeviceType_Web: 5, // c++@him_client_def.h:enum HIMDeviceType
  },
  INT_32_MAX_VALUE: 4294967295,
  DeviceStatus: {
    on: true,
    off: false,
  },
  // 媒体引擎类型
  MediaSource: {
    MediaSAgora: 1,
    MediaSHisrtc: 2,
    MediaSLeiartc: 3,
  },
  // 声网实例化参数
  AGORA_PARAMS: {
    mode: 'live',
    codec: 'h264',
    role: 'host'
  },
  LEIARTC_PARAMS: {
    mode: 'rtc',
    codec: 'h264'
  },
  get QUICK_CONFERENCE_TAG (){ return i18n.tc('home.QuickCollaboration') }, // 快速协作的标签名 // 快速协作不翻译
  // 成员的角色，主要为了区分主持人
  MEMBER_ROLE: {
    ROLE_NORMAL: 0, // 普通成员
    ROLE_HOST: 1, // 主持人
    ROLE_SPECIALIST: 2, // 标注者
  },
  // 声网播放视频时的配置
  AGORA_VIDEO_CONFIG: {
    fit: 'contain',
    mirror: false
  },
  ERole: {
    get 0(){ return i18n.tc('global.Member') },
    get 1(){ return i18n.tc('home.Host') },
    get 2(){ return i18n.tc('calling.Annotator') },
  },
  DRAW_COLOR_MAP: {
    red: '#EB5841',
    yellow: '#F9DE4A',
    green: '#6FDE8D',
    blue: '#47B3FF',
    purple: '#736FDE'
  },
  SLAM_MARK_COLOR_CODE: [
    ['#FDCDD3', '#FFFB8E', '#FFBCA3', '#8EFEFE', '#6FFDA3', '#A7A4E0', '#AAD6FA', '#1C80AD'],
    ['#FC8C80', '#F7E505', '#FF9C5A', '#45EFEF', '#5BCD82', '#C671FE', '#4488FE', '#004EAF'],
    ['#E05250', '#FFD604', '#FF6C3D', '#2DFFCD', '#00DE4F', '#8D4DFF', '#0072FD', '#063978'],
    ['#DA2828', '#FDBA07', '#EB5841', '#009999', '#28AB00', '#7409FF', '#0043FD', '#0C178B'],
    ['#B51D1D', '#FB7600', '#4D1300', '#035C55', '#007229', '#230772', '#031EC8', '#18144F'],
  ],
  // 迷之颜色代码对应
  PUZZLE_COLOR_CODE: {
    '-1353663': 'red',
    '-401846': 'yellow',
    '-9445747': 'green',
    '-12078081': 'blue',
    '-9211938': 'purple',
  },
  DRAW_LINE_WIDTH: {
    s: 2,
    m: 6,
    l: 10,
    xl: 20
  },
  ROLE_ALIAS: {
    get 2() { return i18n.tc('global.Label') }
  },
  IS_GRANT_ROLE: {
    allow: true,
    disallow: false
  },
  CAMERA_CONFIG: {
    '360p': {
      width: 640,
      height: 360,
      bitrateMax: 1000,
      bitrateMin: 900,
      frameRate: 15
    },
    '720p': {
      width: 1280,
      height: 720,
      bitrateMax: 2300,
      bitrateMin: 2200,
      frameRate: 15
    },
    '1080p': {
      width: 1920,
      height: 1080,
      bitrateMax: 4300,
      bitrateMin: 4200,
      frameRate: 15
    },
  },
  // 屏幕共享的声网配置
  AGORA_SCREEN_SHARING_CONFIG_1080: {
    encoderConfig: '1080p_3',
    screenSourceType: 'screen',
    optimizationMode: 'detail'
  },
  AGORA_SCREEN_SHARING_CONFIG_720: {
    encoderConfig: '720p_3',
    screenSourceType: 'screen',
    optimizationMode: 'detail'
  },
  // 屏幕共享的LeiaRTC配置
  LEIARTC_SCREEN_SHARING_CONFIG_1080: {
    encoderConfig: '1080p'
  },
  LEIARTC_SCREEN_SHARING_CONFIG_720: {
    encoderConfig: '720p'
  },
  // 本地屏幕共享的状态
  SCREEN_SHARING_STATUS: {
    on: 'on', // 已开启
    off: 'off', // 已关闭
    pending: 'pending' // 请求信令中
  },
  // 用户状态对应的名称
  MEMBER_STATUS_NAME: {
    get [ESig.MemberStatusType.OUTROOM_USER_LEAVE] () { return i18n.tc('global.Departed') },
    get [ESig.MemberStatusType.OUTROOM_USER_TIMEOUT] () { return i18n.tc('global.Timedout') },
    get [ESig.MemberStatusType.OUTROOM_USER_DROPLINE] () { return i18n.tc('global.Offline') },
    get [ESig.MemberStatusType.OUTROOM_USER_BUSY] () { return i18n.tc('global.OtherBusy') },
    get [ESig.MemberStatusType.OUTROOM_USER_REFUSE] () { return i18n.tc('global.Refused') }
  },
  // 是否是第一次授权麦克风
  MICROPHONEAUTHSTATE: MICROPHONEAUTHSTATES.NONE,
  // 全局版本号
  VERSION: pkg.version,
  // 白板背景颜色
  WHITEBOARDCOLOR: '#213B3E',
  AGORA_STREAM_QUALITY: {
    HIGHT_QUALITY: 0,
    LOW_QUALITY: 1
  },
  LEIARTC_STREAM_QUALITY: {
    HIGHT_QUALITY: 1,
    LOW_QUALITY: 2
  },
}
